import * as React from "react";
const SvgFiRrTogetherPeople = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-together-people_svg__a)">
      <path
        fill="#062147"
        d="M16.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M20 6h-3a1 1 0 1 0 0 2h3c1.103 0 2 .897 2 2v3c0 1.103-.897 2-2 2a1 1 0 1 0 0 2v6a1 1 0 1 0 2 0v-6.556c1.19-.694 2-1.97 2-3.444v-3c0-2.206-1.794-4-4-4M5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m1 10H4c-1.103 0-2-.897-2-2v-3c0-1.103.897-2 2-2h1a1 1 0 1 0 0-2H4c-2.206 0-4 1.794-4 4v3c0 1.474.81 2.75 2 3.444V23a1 1 0 1 0 2 0v-6h2v6a1 1 0 1 0 2 0v-6c0-1.103-.897-2-2-2m1.626-3.54 1.688 1.688a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L10.032 11H14a1 1 0 1 0 0-2H9.994l.734-.734a.999.999 0 1 0-1.414-1.414L7.626 8.54a2.067 2.067 0 0 0 0 2.92m8.748 3.08-1.688-1.688a.999.999 0 1 0-1.414 1.414l.696.734H10a1 1 0 1 0 0 2h4.006l-.734.734a.999.999 0 1 0 1.414 1.414l1.688-1.688a2.067 2.067 0 0 0 0-2.92M17 20a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-together-people_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTogetherPeople;
